import { render, staticRenderFns } from "./globalOtpVerify.vue?vue&type=template&id=1b281b9e&scoped=true&"
import script from "./globalOtpVerify.vue?vue&type=script&lang=js&"
export * from "./globalOtpVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b281b9e",
  null
  
)

export default component.exports